import { useBreedConstants } from "@/app/hooks/useBreedConstants";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import clsx from "clsx";

const PetBreed: React.FC<{ className?: string; petBreedId: number; petSpeciesId: string }> = ({
  petBreedId,
  petSpeciesId,
  className,
}) => {
  const { catBreeds, dogBreeds, giantBreeds } = useBreedConstants();
  const breadDetection = () => {
    if (petSpeciesId === "1") {
      const filteredCatBreeds = dogBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "2") {
      const filteredCatBreeds = catBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "15") {
      const filteredGiantBreeds = giantBreeds.filter((giantBreed) => giantBreed.id === petBreedId);
      return filteredGiantBreeds[0]?.pet_breed;
    } else {
      return "Other";
    }
  };
  return (
    <p className={clsx("text-xs font-normal  text-left tracking-[0px]", className)}>
      {breadDetection() ?? <span className="text-red-500 text-[10px] sm:text-xs">No Breed</span>}
    </p>
  );
};

export default PetBreed;
